var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLovableColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    style: {
      flex: "none",
      lineHeight: 1
    },
    viewBox: "0 0 24 24",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Lovable") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M7.082 0c3.91 0 7.081 3.179 7.081 7.1v2.7h2.357c3.91 0 7.082 3.178 7.082 7.1 0 3.923-3.17 7.1-7.082 7.1H0V7.1C0 3.18 3.17 0 7.082 0z",
    fill: "url(#lobe-icons-lovable-_R_0_)",
    fillRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    gradientTransform: "matrix(-1 22.49999 -30.45394 -1.3535 14 3)",
    gradientUnits: "userSpaceOnUse",
    id: "lobe-icons-lovable-_R_0_",
    r: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FE7B02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    stopColor: "#FE4230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.548,
    stopColor: "#FE529A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "#DD67EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#4B73FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLovableColor);
export default __webpack_public_path__ + "static/media/lovable-color.626bfb1913152817532ce9cb2cc01833.svg";
export { ForwardRef as ReactComponent };